import React from "react";
import styles from "./SinglePhotoProcessing.module.css";

// Helpers
import { ScrollDisable } from "../../helpers/ScrollLock";
import cloneDeep from "lodash.clonedeep";

// Icons
import {
  ArrowDownCircleIcon,
  ArrowLeftCircleIcon,
} from "@heroicons/react/24/outline";

function SinglePhotoProcessing(props) {
  // ImageTwoStatus: Possible status
  // noImageSelected
  // notSentToProcess
  // serverProcessing
  // processed

  const { index, comparisonItems, imageProcessingStatuses, setModalImage } =
    props;

  const figureName = { fileOne: "1", fileTwo: "2" };

  const containerHidden = {
    opacity: "0",
    height: "0",
    position: "absolute",
    transition: "150ms",
    overflow: "hidden",
  };
  const containerVisible = {
    opacity: "100%",
    height: "100%",
    transition: "150ms",
  };
  const pairData = comparisonItems[index];

  const imageProcessingStatus = imageProcessingStatuses[index];

  // Different card is visible depending on status.
  const possibleStatus = () => {
    return (
      <div className="relative flex flex-1 items-center justify-center h-full w-full Xbg-green-500">
        {/* No Image Selected */}
        <div
          className="flex flex-col items-center justify-center h-full w-full"
          style={
            imageProcessingStatus === "noImageSelected"
              ? containerVisible
              : containerHidden
          }
        >
          <div className="flex flex-col items-center justify-center">
            <ArrowLeftCircleIcon className="rotate-90 md:rotate-0 h-52 w-52 stroke-1 text-neutral-400" />
          </div>
          <div className="py-5" />
          <div className="flex flex-col items-center justify-center">
            <p className="text-4xl md:text-3xl font-medium text-neutral-400 text-center">
              No Image Selected
            </p>
            <p className="text-lg font-normal text-neutral-400 text-center">
              Select an image to process
            </p>
          </div>
        </div>

        {/* Not Send to Process */}
        <div
          className="flex flex-col items-center justify-center h-full w-full"
          style={
            imageProcessingStatus === "notSentToProcess"
              ? containerVisible
              : containerHidden
          }
        >
          <div className="flex flex-col items-center justify-center">
            <ArrowDownCircleIcon className="h-52 w-52 stroke-1 text-neutral-400" />
          </div>
          <div className="py-5" />
          <div className="flex flex-col items-center justify-center">
            <p className="text-4xl md:text-3xl font-medium text-neutral-400 text-center">
              Begin Calculation
            </p>
            <p className="text-lg font-normal text-neutral-400 text-center">
              Start by pressing <i>Calculate</i> below
            </p>
          </div>
        </div>

        {/* Server is Processing */}
        <div
          className="flex flex-col items-center justify-center h-full w-full"
          style={
            imageProcessingStatus === "serverProcessing"
              ? containerVisible
              : containerHidden
          }
        >
          <div className="flex flex-col items-center justify-center h-52 w-52">
            <div className={styles["loader"]}></div>
          </div>
          <div className="py-5" />
          <div className="flex flex-col items-center justify-center">
            <p className="text-4xl md:text-3xl font-medium text-neutral-400 text-center">
              Processing...
            </p>
            <p className="text-lg font-normal text-neutral-400 text-center">
              Server is calculating
            </p>
          </div>
        </div>

        {/* Server Processed */}
        <div
          className="flex flex-col items-center justify-center h-full w-full"
          style={
            imageProcessingStatus === "processed"
              ? containerVisible
              : containerHidden
          }
        >
          {pairData.fileTwo[0] && (
            <img
              // * Always an apiItem. No need to send through getImageSrc.
              src={pairData.fileTwo[0].path}
              draggable={false}
              className="object-scale-down
                         transition-all duration-200
                         cursor-pointer hover:scale-105 active:scale-100
                         w-full h-full
                         max-w-[25rem] max-h-[25rem]
                        "
              onClick={() => {
                ScrollDisable();
                setModalImage(pairData.fileTwo[0]);
              }}
            />
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-1 flex-grow flex-col items-center justify-center w-full h-full Xbg-pink-500">
      {/* Need spacer because there aren't any buttons above card. */}
      <div className="flex w-full md:h-16 Xbg-red-500" />

      <div
        className="flex flex-col items-center justify-center w-full h-full min-h-[40rem] py-6 
                      border-2 rounded-xl border-neutral-200 border-solid Xbg-orange-500"
      >
        {/* Container with card */}
        <div className="flex flex-1 flex-col items-center justify-center h-full w-full p-2 Xbg-yellow-500">
          <div
            className="flex flex-1 flex-col items-center justify-between p-2 rounded-xl overflow-hidden Xbg-blue-500
                       outline outline-1
                       w-full h-full
                      "
          >
            <div className="flex flex-1 flex-col items-center justify-between w-full Xbg-red-500">
              {possibleStatus()}
              <div className="flex flex-row w-full">
                <input
                  className="flex w-full items-center p-2 border border-neutral-300 rounded-lg
                            focus:outline-none focus:ring-inset focus:ring-neutral-300
                            text-base font-normal text-neutral-900
                            "
                  placeholder={`Figure ${props.index + 1}.${
                    figureName[props.setFileKey]
                  }.`}
                  value={
                    props.comparisonItems[props.index][
                      `${props.setFileKey}Details`
                    ].caption
                  }
                  onChange={(event) => {
                    const dataCopy = cloneDeep(props.comparisonItems);
                    dataCopy[props.index][
                      `${props.setFileKey}Details`
                    ].caption = event.target.value;
                    props.setComparisonItems(dataCopy);
                  }}
                  maxLength={50}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SinglePhotoProcessing;
